document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.article-content table').forEach(function(table) {

        let maxColumns = 0;

        table.querySelectorAll('tr').forEach(function(row) {
            maxColumns = Math.max(
                maxColumns,
                row.querySelectorAll('th, td').length
            );
        });

        // Обрабатываем только таблицы с 4+ столбцами
        if (maxColumns >= 4) {

            // Создаем обертку
            const wrapper = document.createElement('div');
            wrapper.className = 'table-wrapper';

            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);

            // Проверяем, действительно ли появился горизонтальный скролл
            requestAnimationFrame(function () {

                if (table.scrollWidth > wrapper.clientWidth) {

                    const hint = document.createElement('div');
                    hint.className = 'table-scroll-hint';
                    hint.textContent = '← Swipe horizontally →';

                    wrapper.after(hint);

                    // Скрываем подсказку после первого горизонтального свайпа
                    wrapper.addEventListener('scroll', function () {
                        if (wrapper.scrollLeft > 5) {
                            hint.style.transition = 'opacity .3s ease';
                            hint.style.opacity = '0';

                            setTimeout(function () {
                                hint.remove();
                            }, 300);
                        }
                    }, { once: true });

                }

            });

        }

    });

});